/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, PageGridContainer, Typography2 } from '@coursera/cds-core';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

type Props = {
  title: string | React.ReactNode;
  description?: React.ReactNode;
  badgeActivities: React.ReactNode;
  anchorId?: string;
};

const styles = {
  description: css`
    margin-top: 8px;
  `,
  badgeActivities: css`
    display: flex;
    flex-direction: column;
    gap: 32px;
  `,
};

const SyllabusModule = ({ title, description, badgeActivities, anchorId }: Props) => {
  const eventingProductData = useEventingProductData();

  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_page_section',
    {
      pageSection: {
        sectionName: 'syllabus',
      },
      ...eventingProductData,
    }
  );

  return (
    <Section anchorId={anchorId} ref={visibilityTrackingRef} spacing={24}>
      <PageGridContainer>
        <Grid item xs={12} lg={8} md={7}>
          <Typography2 variant="subtitleLarge" component="h2">
            {title}
          </Typography2>
          {description && <div css={styles.description}>{description}</div>}
        </Grid>
        <Grid item xs={12} lg={8} md={7}>
          <TrackedDiv
            css={styles.badgeActivities}
            trackingName="syllabus"
            trackClicks={false}
            requireFullyVisible={false}
            withVisibilityTracking={true}
          >
            {badgeActivities}
          </TrackedDiv>
        </Grid>
      </PageGridContainer>
    </Section>
  );
};

export default SyllabusModule;
